import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InternetStatus } from "./generalTypes";

export interface internetConnection {
    status: InternetStatus;
}

export const initialState: internetConnection = {
    status: InternetStatus.Online
};

const internetConnectionSlice = createSlice({
    name: "internetConnection",
    initialState,
    reducers: {
        updateInternetStatus(state, action: PayloadAction<internetConnection>) {
            state.status = action.payload.status;
        }
    }
});

export const { updateInternetStatus } = internetConnectionSlice.actions;

export default internetConnectionSlice.reducer;
